import * as React from 'react';

export class WrongBusinessGroupSvg extends React.Component<{}> {

  render() {
    return (
      <svg id="wrong-bg-svg" width="426" height="138" viewBox="0 0 426 138" fill="none" xmlns="http://www.w3.org/2000/svg">
        <line y1="12.5" x2="74" y2="12.5" stroke="white"/>
        <line y1="87.5" x2="74" y2="87.5" stroke="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M350 88H425V76H350V88Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M350 88H425V75H350V88ZM350.625 87.35H424.375V75.65H350.625V87.35Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M350 138H425V75H350V138ZM351.25 136.74H423.75V76.26H351.25V136.74Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M387.388 130H388V129.364H387.388V130Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0 13H75V1H0V13Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 13H75V0H0V13ZM0.625 12.35H74.375V0.65H0.625V12.35Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M0 63H75V0H0V63ZM1.25 61.74H73.75V1.26H1.25V61.74Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M175 88H337V76H175V88Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M175 88H338V75H175V88ZM175.627 87.35H337.373V75.65H175.627V87.35Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M175 138H338V75H175V138ZM176 136.74H336.492V76.26H176V136.74Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M327 129H329V123H327V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M316 129H318V116H316V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M305 129H307V123H305V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M294 129H296V123H294V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M284 129H286V123H284V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M273 129H275V116H273V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M261 129H263V123H261V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M250 129H252V104H250V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M239 129H241V110H239V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M229 129H231V116H229V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M218 129H220V97H218V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M206 129H208V104H206V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M195 129H197V97H195V129Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M185 129H187V104H185V129Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M87.8979 12.2318H249.931V0.313629H87.8979V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 12.5455H250.244V0H87.5854V12.5455ZM88.2111 11.9182H249.618V0.627273H88.2111V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 62.7273H250.244V0H87.5854V62.7273ZM88.8367 61.4727H248.993V1.25455H88.8367V61.4727Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M96.9697 38.2636H240.86V37.0091H96.9697V38.2636Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M192.896 53.9455C205.246 53.9455 211.408 45.8311 217.375 38.0177C223.385 30.1492 229.2 22.5818 240.86 22.5818V21.3273C228.51 21.3273
          222.349 29.4417 216.382 37.255C210.372 45.1235 204.556 52.6909 192.896 52.6909V53.9455ZM144.933 22.5818C156.565 22.5818 162.38 30.1486
          168.397 38.0181C174.372 45.8314 180.547 53.9455 192.896 53.9455V52.6909C181.236 52.6909 175.407 45.1232 169.39 37.2547C163.417 29.4423
          157.255 21.3273 144.933 21.3273V22.5818ZM96.9697 53.9455C109.292 53.9455 115.453 45.8304 121.427 38.0181C127.443 30.1495 133.273 22.5818
          144.933 22.5818V21.3273C132.584 21.3273 126.409 29.4414 120.434 37.2547C114.417 45.1241 108.602 52.6909 96.9697 52.6909V53.9455Z"
          fill="white"
        />
        <path
          opacity="0.3"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.89 127.964C139.061 127.964 135.132 124.024 135.132 119.182C135.132 114.34 139.061 110.4 143.89 110.4C148.72 110.4 152.649 114.34
          152.649 119.182C152.649 124.024 148.72 127.964 143.89 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M143.89 109.773C138.707 109.773 134.506 113.985 134.506 119.182C134.506 124.378 138.707 128.591 143.89
          128.591C149.073 128.591 153.274 124.378 153.274 119.182C153.274 113.985 149.073 109.773 143.89 109.773ZM143.89 111.027C148.374 111.027
          152.023 114.686 152.023 119.182C152.023 123.678 148.374 127.336 143.89 127.336C139.406 127.336 135.757 123.678 135.757 119.182C135.757
          114.686 139.406 111.027 143.89 111.027Z"
          fill="white"
        />
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M87.8979 87.5045H162.346V75.5864H87.8979V87.5045Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 87.8182H162.659V75.2727H87.5854V87.8182ZM88.2111 87.1909H162.033V75.9H88.2111V87.1909Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M87.5854 138H162.659V75.2727H87.5854V138ZM88.8367 136.745H161.407V76.5273H88.8367V136.745Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.61 127.964C104.331 127.964 97.5952 121.21 97.5952 112.909C97.5952 104.608 104.331 97.8546 112.61 97.8546C120.889 97.8546 127.624
          104.608 127.624 112.909C127.624 121.21 120.889 127.964 112.61 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M112.61 97.2273C103.972 97.2273 96.9697 104.248 96.9697 112.909C96.9697 121.57 103.972 128.591 112.61 128.591C121.248 128.591 128.25
          121.57 128.25 112.909C128.25 104.248 121.248 97.2273 112.61 97.2273ZM112.61 98.4818C120.544 98.4818 126.999 104.954 126.999 112.909C126.999
          120.864 120.544 127.336 112.61 127.336C104.676 127.336 98.2209 120.864 98.2209 112.909C98.2209 104.954 104.676 98.4818 112.61 98.4818Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M132.629 97.2273C125.719 97.2273 120.117 102.844 120.117 109.773C120.117 116.702 125.719 122.318 132.629 122.318C139.54 122.318 145.142
          116.702 145.142 109.773C145.142 102.844 139.54 97.2273 132.629 97.2273ZM132.629 98.4818C138.839 98.4818 143.89 103.547 143.89
          109.773C143.89 115.999 138.839 121.064 132.629 121.064C126.42 121.064 121.368 115.999 121.368 109.773C121.368 103.547 126.42 98.4818
          132.629 98.4818Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M283.152 53.3182H284.403V40.7727H283.152V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M272.14 53.3182H273.391V34.5H272.14V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M294.161 53.3182H295.412V28.2273H294.161V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M305.173 53.3182H306.424V34.5H305.173V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M316.182 53.3182H317.433V40.7727H316.182V53.3182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M327.194 53.3182H328.445V21.9546H327.194V53.3182Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M263.069 12.2318H337.516V0.313629H263.069V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M262.756 12.5455H337.829V0H262.756V12.5455ZM263.381 11.9182H337.203V0.627273H263.381V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M262.756 62.7273H337.829V0H262.756V62.7273ZM264.007 61.4727H336.578V1.25455H264.007V61.4727Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 25.7182H378.494V24.4636H372.238V25.7182Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 38.2636H378.494V37.0091H372.238V38.2636Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M372.238 50.8091H378.494V49.5545H372.238V50.8091Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M350.654 12.2318H425.102V0.313629H350.654V12.2318Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.341 12.5455H425.414V0H350.341V12.5455ZM350.967 11.9182H424.789V0.627273H350.967V11.9182Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M350.341 62.7273H425.414V0H350.341V62.7273ZM351.593 61.4727H424.163V1.25455H351.593V61.4727Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M400.39 21.9546C391.752 21.9546 384.75 28.9756 384.75 37.6364C384.75 46.2971 391.752 53.3182 400.39 53.3182C409.028 53.3182 416.03
          46.2971 416.03 37.6364C416.03 28.9756 409.028 21.9546 400.39 21.9546ZM400.39 23.2091C408.324 23.2091 414.779 29.6813 414.779
          37.6364C414.779 45.5914 408.324 52.0637 400.39 52.0637C392.456 52.0637 386.001 45.5914 386.001 37.6364C386.001 29.6813 392.456 23.2091
          400.39 23.2091Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M401.016 38.2636H415.392C415.071 46.0666 408.798 52.3566 401.016 52.6781V38.2636Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M416.03 37.6364H400.39V53.3182C409.028 53.3182 416.03 46.2971 416.03 37.6364ZM414.725 38.8909C414.125 45.848 408.58 51.4078 401.641
          52.0097V38.8909H414.725Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 27.6C361.474 27.6 360.351 26.4744 360.351 25.0909C360.351 23.7075 361.474 22.5818 362.854 22.5818C364.233 22.5818 365.356
          23.7075 365.356 25.0909C365.356 26.4744 364.233 27.6 362.854 27.6Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 21.9546C361.126 21.9546 359.726 23.359 359.726 25.0909C359.726 26.8228 361.126 28.2273 362.854 28.2273C364.581 28.2273 365.982
          26.8228 365.982 25.0909C365.982 23.359 364.581 21.9546 362.854 21.9546ZM362.854 23.2091C363.889 23.2091 364.73 24.0531 364.73
          25.0909C364.73 26.1287 363.889 26.9727 362.854 26.9727C361.819 26.9727 360.977 26.1287 360.977 25.0909C360.977 24.0531 361.819 23.2091
          362.854 23.2091Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 40.1454C361.474 40.1454 360.351 39.0198 360.351 37.6363C360.351 36.2529 361.474 35.1273 362.854 35.1273C364.233 35.1273
          365.356 36.2529 365.356 37.6363C365.356 39.0198 364.233 40.1454 362.854 40.1454Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 34.5C361.126 34.5 359.726 35.9045 359.726 37.6364C359.726 39.3683 361.126 40.7727 362.854 40.7727C364.581 40.7727 365.982
          39.3683 365.982 37.6364C365.982 35.9045 364.581 34.5 362.854 34.5ZM362.854 35.7545C363.889 35.7545 364.73 36.5985 364.73 37.6364C364.73
          38.6742 363.889 39.5182 362.854 39.5182C361.819 39.5182 360.977 38.6742 360.977 37.6364C360.977 36.5985 361.819 35.7545 362.854 35.7545Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 52.6909C361.474 52.6909 360.351 51.5653 360.351 50.1818C360.351 48.7984 361.474 47.6727 362.854 47.6727C364.233 47.6727
          365.356 48.7984 365.356 50.1818C365.356 51.5653 364.233 52.6909 362.854 52.6909Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M362.854 47.0455C361.126 47.0455 359.726 48.4499 359.726 50.1818C359.726 51.9137 361.126 53.3182 362.854 53.3182C364.581 53.3182 365.982
          51.9137 365.982 50.1818C365.982 48.4499 364.581 47.0455 362.854 47.0455ZM362.854 48.3C363.889 48.3 364.73 49.144 364.73 50.1818C364.73
          51.2197 363.889 52.0637 362.854 52.0637C361.819 52.0637 360.977 51.2197 360.977 50.1818C360.977 49.144 361.819 48.3 362.854 48.3Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8965 100.991H28.1526V99.7364H21.8965V100.991Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8965 113.536H28.1526V112.282H21.8965V113.536Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M21.8965 126.082H28.1526V124.827H21.8965V126.082Z" fill="white"/>
        <path opacity="0.5" fillRule="evenodd" clipRule="evenodd" d="M0.312744 87.5045H74.7603V75.5864H0.312744V87.5045Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 87.8182H75.0732V75.2727H0V87.8182ZM0.62561 87.1909H74.4476V75.9H0.62561V87.1909Z"
          fill="white"
        />
        <path fillRule="evenodd" clipRule="evenodd" d="M0 138H75.0732V75.2727H0V138ZM1.25122 136.745H73.822V76.5273H1.25122V136.745Z" fill="white"/>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.0489 97.2273C41.4111 97.2273 34.4087 104.248 34.4087 112.909C34.4087 121.57 41.4111 128.591 50.0489 128.591C58.6867 128.591 65.6892
          121.57 65.6892 112.909C65.6892 104.248 58.6867 97.2273 50.0489 97.2273ZM50.0489 98.4818C57.9829 98.4818 64.438 104.954 64.438
          112.909C64.438 120.864 57.9829 127.336 50.0489 127.336C42.115 127.336 35.6599 120.864 35.6599 112.909C35.6599 104.954 42.115 98.4818
          50.0489 98.4818Z"
          fill="white"
        />
        <path
          opacity="0.5"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M50.6743 113.536H65.0505C64.7299 121.339 58.4566 127.629 50.6743 127.951V113.536Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M65.6891 112.909H50.0488V128.591C58.6866 128.591 65.6891 121.57 65.6891 112.909ZM64.3841 114.164C63.7838 121.121 58.2387 126.681 51.3
          127.282V114.164H64.3841Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 102.873C11.1324 102.873 10.0098 101.747 10.0098 100.364C10.0098 98.9802 11.1324 97.8546 12.5122 97.8546C13.892 97.8546 15.0146
          98.9802 15.0146 100.364C15.0146 101.747 13.892 102.873 12.5122 102.873Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5123 97.2273C10.7847 97.2273 9.38428 98.6317 9.38428 100.364C9.38428 102.096 10.7847 103.5 12.5123 103.5C14.2399 103.5 15.6404
          102.096 15.6404 100.364C15.6404 98.6317 14.2399 97.2273 12.5123 97.2273ZM12.5123 98.4818C13.5474 98.4818 14.3892 99.3258 14.3892
          100.364C14.3892 101.401 13.5474 102.245 12.5123 102.245C11.4773 102.245 10.6355 101.401 10.6355 100.364C10.6355 99.3258 11.4773
          98.4818 12.5123 98.4818Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 115.418C11.1324 115.418 10.0098 114.293 10.0098 112.909C10.0098 111.526 11.1324 110.4 12.5122 110.4C13.892 110.4 15.0146
          111.526 15.0146 112.909C15.0146 114.293 13.892 115.418 12.5122 115.418Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5123 109.773C10.7847 109.773 9.38428 111.177 9.38428 112.909C9.38428 114.641 10.7847 116.045 12.5123 116.045C14.2399 116.045 15.6404
          114.641 15.6404 112.909C15.6404 111.177 14.2399 109.773 12.5123 109.773ZM12.5123 111.027C13.5474 111.027 14.3892 111.871 14.3892
          112.909C14.3892 113.947 13.5474 114.791 12.5123 114.791C11.4773 114.791 10.6355 113.947 10.6355 112.909C10.6355 111.871 11.4773 111.027
          12.5123 111.027Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5122 127.964C11.1324 127.964 10.0098 126.838 10.0098 125.455C10.0098 124.071 11.1324 122.945 12.5122 122.945C13.892 122.945 15.0146
          124.071 15.0146 125.455C15.0146 126.838 13.892 127.964 12.5122 127.964Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.5123 122.318C10.7847 122.318 9.38428 123.723 9.38428 125.455C9.38428 127.186 10.7847 128.591 12.5123 128.591C14.2399 128.591 15.6404
          127.186 15.6404 125.455C15.6404 123.723 14.2399 122.318 12.5123 122.318ZM12.5123 123.573C13.5474 123.573 14.3892 124.417 14.3892
          125.455C14.3892 126.492 13.5474 127.336 12.5123 127.336C11.4773 127.336 10.6355 126.492 10.6355 125.455C10.6355 124.417 11.4773 123.573
          12.5123 123.573Z"
          fill="white"
        />
        <rect opacity="0.5" x="9" y="33" width="15" height="21" fill="white"/>
        <rect opacity="0.5" x="37" y="21" width="16" height="33" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M23 34H10V53H23V34ZM9 33V54H24V33H9Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M37 41H24V53H37V41ZM23 40V54H38V40H23Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M52 22H38V53H52V22ZM37 21V54H53V21H37Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M66 28H53V53H66V28ZM52 27V54H67V27H52Z" fill="white"/>
        <rect opacity="0.5" x="359" y="109" width="15" height="21" fill="white"/>
        <rect opacity="0.5" x="387" y="97" width="16" height="33" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M373 110H360V129H373V110ZM359 109V130H374V109H359Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M387 117H374V129H387V117ZM373 116V130H388V116H373Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M402 98H388V129H402V98ZM387 97V130H403V97H387Z" fill="white"/>
        <path fillRule="evenodd" clipRule="evenodd" d="M416 104H403V129H416V104ZM402 103V130H417V103H402Z" fill="white"/>
        <line x1="88" y1="12.5" x2="250" y2="12.5" stroke="white"/>
        <line x1="88" y1="87.5" x2="162" y2="87.5" stroke="white"/>
        <line x1="175" y1="87.5" x2="337" y2="87.5" stroke="white"/>
        <line x1="263" y1="12.5" x2="337" y2="12.5" stroke="white"/>
        <line x1="351" y1="87.5" x2="425" y2="87.5" stroke="white"/>
        <line x1="351" y1="12.5" x2="425" y2="12.5" stroke="white"/>
      </svg>

    )
  }
}